import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import style from "./index.module.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
